// Blog 하단 버튼 전용 : 깃허브, 블로그 외부 연결 링크

export const LINK_DATA = [
  {
    id: "gh-1",
    label: "github (현재)",
    url: "https://github.com/jeonnni",
  },
  {
    id: "gh-2",
    label: "github (아카이브)",
    url: "https://github.com/ol7mi",
  },
  {
    id: "bl-1",
    label: "tistory",
    url: "https://yong-mi.tistory.com/",
  },
  {
    id: "bl-2",
    label: "naver",
    url: "https://blog.naver.com/jeonnni",
  },
];
